
function waitForElementAndVisible(selector, callback, checkInterval = 100, timeout = 10000) {
    const startTime = Date.now();

    const interval = setInterval(function() {
        const $elements = $(selector);

        if ($elements.length > 0) {
            const visibleCount = $elements.filter(':visible').length;

            if (visibleCount > 0) {
                clearInterval(interval);
                callback(visibleCount);
            }
        }

        if (Date.now() - startTime > timeout) {
            clearInterval(interval);
        }
    }, checkInterval);
}

waitForElementAndVisible('.pd-cookie-banner-window', function(visibleCount) {
    $('body').addClass('cookies_not_accepted');
});

$(document).on('click', '.cc-allow, .cc-close, .pd-cp-btn.pd-cp-ui-save', function() {
    $('body').removeClass('cookies_not_accepted');
});

$('body').on('click', function(event) {
   const $banner = $('.pd-cookie-banner-window');
   const $pandectes = $('#pandectes-banner');

   if ($banner.is(event.target) || $banner.has(event.target).length > 0) {
   } else {
       if (!$pandectes.hasClass('cc-invisible')) {
           $('body').addClass('cookies_not_accepted');
       } else {
           $('body').removeClass('cookies_not_accepted');
       }
   }
});
$(document).on('click', '#omnisend-dynamic-container', function(event) {

 setTimeout(function() {
 $('body').addClass('cookies_not_accepted');
}, 100);

 
});


$(document).on('click', '.cc-revoke', function() {
 setTimeout(function() {
   $('body').addClass('cookies_not_accepted');
 }, 100);
});

let classRemoved = false;

$(window).on('scroll', function() {
   if (!classRemoved && $(window).scrollTop() >= 200) {
       $('body').removeClass('cookies_not_accepted');
       classRemoved = true;
   }
});